import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_DARK} from 'ui-library/Colors';
import ErrorMessage from 'ui-library/ErrorMessage';
import {FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

import {ProcessExecutionType} from '../../graphql-client/__generated/graphqlGlobalTypes';
import ConfigureExecutionTemplateButton, {
  EntryTemplateForConfigureButton,
  OnTemplateParametersChangeArgs,
} from './ConfigureExecutionTemplateButton';

interface ConfigureEntryTemplateProps {
  executionType: ProcessExecutionType;
  executionTemplate: EntryTemplateForConfigureButton;
  isDisabled?: boolean;
  onChange: (args: OnTemplateParametersChangeArgs) => void;
  error?: string;
}

export default function ConfigureExecutionTemplateSection(props: ConfigureEntryTemplateProps): JSX.Element {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <div>
      <InputWrapper
        id="execution-template-field"
        label="Execution template"
        isRequired={props.executionType === ProcessExecutionType.ENTRY}
        labelStyle={FieldLabel.STYLES.LABEL}
        help={
          BenchlingConfig.ELN_ENABLE_TEMPLATE_PUBLISHING
            ? 'Execution templates must be published so users can execute tasks created with this schema.'
            : undefined
        }
        helpInteraction={
          BenchlingConfig.ELN_ENABLE_TEMPLATE_PUBLISHING ? FloatingInteraction.HOVER : undefined
        }
      >
        <div
          className={classNames(css(styles.executionTemplateContainer), {
            editableField: props.executionTemplate != null,
          })}
          onMouseEnter={() => {
            setIsHovering(true);
          }}
          onMouseLeave={() => {
            setIsHovering(false);
          }}
        >
          {props.executionType === ProcessExecutionType.ENTRY ? (
            <ConfigureExecutionTemplateButton
              entryTemplate={props.executionTemplate}
              onChange={props.onChange}
              isDisabled={props.isDisabled}
              isHovering={isHovering}
              buttonLabel="Configure"
              modalTitle="Configure execution template"
            />
          ) : (
            <span
              className={css(styles.descriptionText)}
              {...getTestProps({
                component: 'ConfigureExecutionTemplateSection',
                element: 'templateNotAvailable',
              })}
            >
              This setting is only available if execution type is Entry.
            </span>
          )}
        </div>
      </InputWrapper>
      {props.error && <ErrorMessage error={props.error} />}
    </div>
  );
}

const styles = StyleSheet.create({
  executionTemplateContainer: {
    width: '100%',
  },
  descriptionText: {
    color: GRAY_DARK,
    fontSize: '13px',
    lineHeight: '16px',
  },
});
